import React from "react";
import Big from "big.js";
import { Button, Table, Select, Tag, Input, Checkbox } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import InputNumberField from "../../../../components/Input/InputNumber";
import ReturnDataTableFooter from "../../../../components/DataTableFooter/ReturnDataTableFooter";
import { getCurrencySymbol } from "../../../../lib/currency";
import { accessChecker } from "../../../../lib/functions";

const SalesReturnTable = ({
  handleDeleteRow,
  handleFooterChange,
  handleInputChange,
  footerValues,
  itemsList,
  onUpdateServices,
  authInfo,
  handleItemChange
}) => {
  const symbol = getCurrencySymbol(authInfo?.currency);
  const showTatmeenColumn =
    authInfo?.is_tatmeen_enabled === "yes" &&
    authInfo?.country === "United Arab Emirates" && (authInfo?.subscription == 'PharmaERP_Pro' || authInfo?.subscription == 'PharmaERP_Standard' || authInfo?.subscription == 'PharmaERP_Basic');
  const hasTatmeenEntryAccess = accessChecker("tatmeen_entry");

  const columns = [
    ...(hasTatmeenEntryAccess && showTatmeenColumn ? [{
      title: "Tatmeen Required",
      dataIndex: "is_tatmeen_required",
      width: 140,
      render: (_, record) => {
        const isRequired = record.is_tatmeen_required === true ||
          record.is_tatmeen_required === 1 ||
          record.is_tatmeen_required === "1";

        return (
          <Checkbox
            checked={isRequired}
            onChange={(e) => {
              const checked = e.target.checked;

              handleItemChange(record.key, {
                is_tatmeen_required: checked,

                ...(checked
                  ? {}
                  : {
                    selectedSerials: [],
                    child_sscc_code: "",
                  }),
              });
            }}
          >
            Required
          </Checkbox>
        );
      },
    }] : []),
    {
      title: "Product",
      dataIndex: "product",
      width: 300,
      render: (_, record) => (
        <div style={{ position: "relative" }}>
          <div>{record?.display_text || record?.product || ""}</div>
          {console.log(record, "record")}

          {record?.item_description &&
            (<p
              style={{
                margin: 0,
                fontSize: 12,
                color: "#666",
                whiteSpace: "pre-wrap",
              }}>{record.item_description}</p>)}
        </div>),
    },
    {
      title: "Quantity",
      dataIndex: "available_qty",
      render: (_, record) => (
        <InputNumberField
          min={0}
          precision={0}
          controls={false}
          value={record.available_qty}
          // value={record.available_qty ?? 0}
          disabled
          style={{ width: "100%" }}
        />
      ),
    },
    {
      title: "Return Quantity",
      dataIndex: "return_quantity",
      render: (_, record) => (
        <InputNumberField
          min={0}
          precision={1}
          step={0.5}
          max={record.available_qty}
          controls={false}
          value={record.return_quantity}
          onFocus={() => {
            setTimeout(() => {
              handleInputChange(undefined, record.key, "return_quantity");
            }, 0);
          }}
          onChange={(value) => {
            handleInputChange(value, record.key, "return_quantity");

            if (
              record.otherServiceTransactions &&
              Array.isArray(record.otherServiceTransactions)
            ) {
              const updatedServices = record.otherServiceTransactions.map(
                (service) => {
                  const perUnit = service.service_amount_per_unit;
                  const total = perUnit * value;

                  return {
                    ...service,
                    updated_service_total: parseFloat(total.toFixed(2)), // store calculated total
                  };
                }
              );
              // handleFooterChange(
              //   ...updatedServices,
              //   updatedServices,
              //   "updatedServices"
              // );
              onUpdateServices(updatedServices, record.key);
              // handleInputChange(updatedServices, record.key, "updatedServices");

              // handleInputChange(
              //   updatedServices,
              //   record.key,
              //   "updatedServiceAllocations"
              // );
              // updatedItemCart[index].updatedServiceAllocations =
              //   updatedServices;
            }
          }}
          style={{ width: "100%" }}
        />
      ),
    },
    ...(hasTatmeenEntryAccess
      ? [
        {
          title: "Mode",
          width: 90,
          render: (_, record) => (
            <Tag color={record.serial_mode === "batch" ? "blue" : "green"}>
              {record.serial_mode === "batch" ? "Batch" : "Unit"}
            </Tag>
          ),
        },
        {
          title: "Child SSCC Code",
          width: 220,

          render: (_, record) => (
            <Input
              value={record.child_sscc_code || ""}
              placeholder="Enter Child SSCC"

              onChange={(e) =>
                handleInputChange(
                  e.target.value,
                  record.key,
                  "child_sscc_code"
                )
              }
            />
          ),
        },
        {
          title: "Serial Numbers",
          width: 250,

          render: (_, record) => (

            <Select
              mode="multiple"
              style={{ width: "100%" }}



              value={
                record.selectedSerials || []
              }

              options={
                (record.availableSerials || []).map((serial) => ({
                  label: serial,
                  value: serial,
                }))
              }

              onChange={(value) =>
                handleInputChange(
                  value,
                  record.key,
                  "selectedSerials"
                )
              }
            />
          ),
        },
      ]
      : []),
    {
      title: "Rate",
      dataIndex: "rate",
      render: (_, record) => (
        <InputNumberField
          min={0}
          step={0.01}
          precision={2}
          controls={false}
          value={record.rate}
          disabled
          style={{ width: "100%" }}
          prefix={symbol}
        />
      ),
    },
    {
      title: "Total",
      dataIndex: "total",
      render: (_, record) => {
        const quantity = Number(record.return_quantity || 0);
        const rate = Number(record.rate || 0);
        const total = new Big(quantity).times(rate).toNumber();
        return (
          <InputNumberField
            controls={false}
            precision={2}
            value={parseFloat(total.toFixed(2))}
            disabled
            style={{ width: "100%" }}
            prefix={symbol}
          />
        );
      },
    },
    {
      title: "",
      dataIndex: "actions",
      render: (_, record) => (
        <Button
          icon={<DeleteOutlined />}
          danger
          disabled
          onClick={() => handleDeleteRow(record.key)}
        // disabled={itemsList.length === 1}
        />
      ),
    },
  ];
  console.log(itemsList, "itemsList123123");

  return (
    <Table
      dataSource={itemsList}
      columns={columns}
      pagination={false}
      rowKey="key"
      scroll={{ x: "min-content" }}
      footer={() => (
        <ReturnDataTableFooter
          footerValues={footerValues}
          dataSource={itemsList}
          onFooterChange={handleFooterChange}
          pageType="salesReturn"
          authInfo={authInfo}
        />
      )}
    />
  );
};

export default SalesReturnTable;
